export const CHANGELOG = [
  {
    version: "4.0.9",
    date: "2026-09-03",
    title: "ثبت و تغییر ایمیل و شماره همراه",
    changes: [
      {
        type: "new",
        text: "حالا از پروفایل خودت می‌تونی ایمیل و شماره همراهت رو ثبت یا عوض کنی. برای ایمیل، کد تأیید به همون ایمیل جدید فرستاده می‌شه (اگر تو صندوق ورودی نبود، پوشه اسپم رو هم نگاه کن) و برای شماره همراه، کد پیامک می‌شه. تا وقتی کد رو وارد نکنی هیچی روی حسابت ثبت نمی‌شه.",
      },
      {
        type: "improved",
        text: "هر کدوم از این دو تا رو هر ۲۴ ساعت یک بار می‌شه تغییر داد و اگر زود باشه، همون‌جا بهت می‌گه چقدر مونده. این کار فقط از پروفایل خودِ آدم انجام می‌شه؛ هیچ مدیری نمی‌تونه ایمیل یا شماره‌ی یکی دیگه رو عوض کنه.",
      },
    ],
  },
  {
    version: "4.0.8",
    date: "2026-09-03",
    title: "ورود با حساب گوگل",
    changes: [
      {
        type: "new",
        text: "کنار ورود با شماره همراه، دکمه‌ی «ورود با حساب گوگل» به صفحه‌ی ورود اضافه شد. فقط برای ورود است و باهاش ثبت‌نام نمی‌شه: ایمیل حساب گوگل باید از قبل در پروفایل همون کاربر ثبت شده باشه، وگرنه پیام «کاربری با این ایمیل یافت نشد» می‌گیری. همین توضیح روی علامت راهنمای کنار دکمه هم هست.",
      },
    ],
  },
  {
    version: "4.0.7",
    date: "2026-09-03",
    title: "ورود تازه، ناوبری کنار صفحه و صیقل اعلان‌ها",
    changes: [
      {
        type: "new",
        text: "تنظیم اعلان‌ها به پروفایل اضافه شد: اعلان پیامکی و اعلان روی گوشی و مرورگر رو جدا از هم می‌تونی خاموش یا روشن کنی. هر کلید بلافاصله ذخیره می‌شه و کد ورود همیشه پیامک می‌شه و به این تنظیم ربطی نداره.",
      },
      {
        type: "new",
        text: "صفحه‌ی ورود و ثبت‌نام بازطراحی شد و تصویر پس‌زمینه‌ی مخصوص دارک و موبایل گرفت. جابه‌جایی بین مجموعه‌ها هم دیگه پرش نداره و با یک صفحه‌ی انتقال کوتاه انجام می‌شه.",
      },
      {
        type: "improved",
        text: "تب‌های صفحه‌های چندبخشی (حضور و غیاب، نامه‌نگاری، تیکت‌ها و پرونده‌ی مشتری) روی نمایشگر پهن به ریل دوم سایدبار منتقل شدن؛ روی موبایل همون نوار تب بالای صفحه می‌مونه. فضای عمودی بیشتری برای خود کار آزاد شد و جابه‌جایی بین تب‌ها سبک‌تر شد.",
      },
      {
        type: "improved",
        text: "پرونده‌ی مشتری حالا نمایندگان، پروژه‌ها و تسک‌ها، تیکت‌ها، یادداشت‌ها و فایل‌ها رو با شمارنده کنار هر تب نشون می‌ده و راهنمای صفحه‌ی مشتریان بازنویسی شد؛ متن قبلی کپیِ راهنمای «کاربران» بود و مشتری رو مثل عضو سازمان توضیح می‌داد.",
      },
      {
        type: "improved",
        text: "در صفحه‌ی اشتراک، هزینه و سقف پیامک بر اساس تعداد کاربران مجموعه حساب می‌شه و کنار هر گزینه توضیحش اومده؛ سقف فضای پیوست پلن نقره‌ای هم به ۱ تا ۱۰۰ گیگابایت اصلاح شد.",
      },
      {
        type: "fixed",
        text: "کارت‌های صفحه‌ی اعلان‌ها بوردر پررنگ و ناهماهنگ می‌گرفتن و به هم چسبیده بودن؛ رنگ حاشیه‌ی اعلان خوانده‌نشده در تم روشن و تیره درست شد و بین کارت‌ها فاصله افتاد. همین اشکال در فهرست کشویی اعلان‌های هدر هم برطرف شد.",
      },
      {
        type: "fixed",
        text: "چند جای پنل در تم تیره رنگ تم روشن رو نگه می‌داشت (فید فعالیت، دسترسی سریع، حضور و غیاب، سازمان و پروفایل کاربر)؛ همه‌شون حالا از رنگ‌های تم پیروی می‌کنن.",
      },
    ],
  },
  {
    version: "4.0.3",
    date: "2026-09-02",
    title: "ساخت سریع تسک، صیقل تخته و پنل جمع‌وجورتر پروژه",
    changes: [
      {
        type: "new",
        text: "ته هر ستون تخته یک کادر ساخت سریع اضافه شد: عنوان رو بنویس و Enter بزن، تسک ساخته می‌شه و کادر برای بعدی باز می‌مونه. چند خط رو هم می‌تونی یک‌جا بچسبونی تا هر خط یک تسک بشه؛ برای بقیه‌ی فیلدها هم «ساخت با جزئیات کامل» همون فرم کامل رو با عنوانی که نوشتی باز می‌کنه.",
      },
      {
        type: "new",
        text: "زیرتسک‌ها رو می‌شه دسته‌جمعی ساخت: عنوان بنویس و Enter بزن تا به لیست اضافه بشه، یا یک فهرست چندخطی رو بچسبون. قبل از ثبت می‌تونی هر ردیف رو ویرایش یا حذف کنی و همه با یک درخواست ساخته می‌شن.",
      },
      {
        type: "new",
        text: "عنوان هر زیرتسک از روی همون ردیف قابل ویرایشه؛ دیگه برای اصلاح یک تایپو لازم نیست زیرتسک رو باز کنی.",
      },
      {
        type: "improved",
        text: "هدر بزرگ صفحه‌ی پروژه برداشته شد و اطلاعاتش (وضعیت، پیشرفت و موعد) به پنل کناری منتقل شد؛ حالا همه‌ی تب‌های پروژه حدود ۸۰ پیکسل ارتفاع بیشتری برای خود کار دارن. موعد وقتی نزدیک یا گذشته باشه رنگی می‌شه.",
      },
      {
        type: "improved",
        text: "نوار ابزار تسک‌ها بازطراحی شد: ویوهای ذخیره‌شده به‌جای تب، به‌شکل چیپ در اومدن و با بقیه‌ی کنترل‌های نوار هم‌زبان شدن. لیست تسک‌ها هم تمام‌عرض شد.",
      },
      {
        type: "improved",
        text: "کارت‌های لیست پروژه سبک‌تر شدن و هدر صفحه مرتب‌تر شد؛ انتخاب «فعال / آرشیو / همه» رفت داخل فیلترها و اگه روی حالتی غیر از فعال باشی، روی دکمه‌ی فیلترها نشون داده می‌شه.",
      },
      {
        type: "fixed",
        text: "راهنمای ساخت پروژه وقتی تموم می‌شد یا بسته می‌شد، فرم رو روی آخرین قدم رها می‌کرد؛ حالا به قدم اول برمی‌گرده.",
      },
      {
        type: "fixed",
        text: "ساخت چندتایی تسک یا زیرتسک، به‌ازای هر مورد یک پیام «تخته به‌روزرسانی شد» می‌داد و تخته را همان‌قدر بار تازه می‌کرد؛ حالا یک بار، آخر کار.",
      },
    ],
  },
  {
    version: "4.0.0",
    date: "2026-09-01",
    title: "تردد شخصی، گزارش حضور و غیاب و صیقل سراسری",
    changes: [
      {
        type: "new",
        text: "صفحه‌ی «تردد من» اضافه شد تا هر کاربر ترددهای خودش را ببیند و درخواست مرخصی، مأموریت یا اصلاح تردد را بدون ورود به فضای مدیریتی ثبت و پیگیری کند.",
      },
      {
        type: "new",
        text: "ثبت ورود و خروج حالا موقعیت مکانی را روی نقشه کنترل می‌کند: محل‌های کار با شعاع مجاز تعریف می‌شن و پیش از ثبت، فاصله‌ی تو تا نزدیک‌ترین محل نشان داده می‌شه.",
      },
      {
        type: "new",
        text: "گزارش حضور و غیاب به بخش گزارش‌ها اضافه شد؛ کارکرد، تأخیر، اضافه‌کاری و غیبت را در بازه‌ی دلخواه ببین و خروجی اکسل بگیر.",
      },
      {
        type: "improved",
        text: "گزارش‌ها و تب‌های حضور و غیاب بازه‌ی دلخواه گرفتن؛ بازه‌های خیلی بزرگ هم محدود شدن تا گزارش سنگین به پایگاه داده فشار وارد نکنه.",
      },
      {
        type: "improved",
        text: "پیشخوان شخصی جمع‌وجورتر شد؛ ثبت ورود و خروج به نوار «امروز» منتقل شد و این نوار حالا خودش رو با ماژول‌های روشن تطبیق می‌ده، پس خاموش کردن حضور و غیاب یا ثبت زمان چیدمان رو به‌هم نمی‌ریزه.",
      },
      {
        type: "improved",
        text: "تب‌های «ماژول‌ها» و «انتقال داده‌ها» که از بازطراحی نسخه‌ی قبل جا مونده بودن هم سربرگ و قاب مشترک بقیه‌ی تب‌های تنظیمات سازمان رو گرفتن.",
      },
      {
        type: "fixed",
        text: "منوهای پروفایل و تعویض سازمان پایدارتر و هم‌شکل‌تر شدن؛ انتخاب‌ها حالا از خود منو انجام می‌شن، نشانگر سبز آنلاین درست روی آواتار می‌شینه و افزودن سازمان بعد از رسیدن به سقف ۳ سازمان غیرفعال می‌شه.",
      },
    ],
  },
  {
    version: "3.9.9",
    date: "2026-08-31",
    title: "فضای کاری انتخابی، انتقال پروژه و تنظیمات مرتب‌تر",
    changes: [
      {
        type: "new",
        text: "ماژول نامه‌نگاری اضافه شد: کارتابل، نامه‌های وارده و صادره و داخلی، پیش‌نویس، گردش امضا، شماره‌گذاری رسمی سال شمسی، دفتر اندیکاتور، بایگانی، پیوست، تاریخچه و خروجی اکسل.",
      },
      {
        type: "new",
        text: "ماژول حضور و غیاب اضافه شد: ثبت ورود و خروج، شیفت و روزهای کاری، محاسبه تأخیر و اضافه‌کاری، مرخصی و مأموریت با گردش تأیید، اصلاح تردد، تعطیلات سازمانی و خروجی اکسل کارکرد.",
      },
      {
        type: "new",
        text: "از تنظیمات سازمان می‌تونی پروژه‌های Jira و Trello رو با فایل خروجی منتقل کنی. قبل از شروع، تعداد پروژه‌ها و تسک‌ها رو می‌بینی و وضعیت‌ها و کاربران منبع رو با فضای کاری خودت تطبیق می‌دی.",
      },
      {
        type: "new",
        text: "انتقال پروژه‌ها در پس‌زمینه انجام می‌شه، پیشرفتش قابل مشاهده‌ست و آخر کار گزارش نتیجه و خطاها رو می‌بینی. اجرای دوباره‌ی یک فایل هم پروژه‌های قبلی رو تکراری نمی‌سازه.",
      },
      {
        type: "new",
        text: "ثبت و گزارش زمان به ماژول‌های اختیاری اضافه شد. چت، مشتریان و ثبت زمان برای فضای کاری تازه به‌صورت پیش‌فرض روشنن و هر بخش خاموش باشه از منو و مسیرهای پنل کنار می‌ره، بدون اینکه اطلاعاتش پاک بشه.",
      },
      {
        type: "improved",
        text: "انتخاب ماژول‌ها توی راه‌اندازی اولیه و تنظیمات سازمان جمع‌وجور و واکنش‌گرا شد؛ روی دسکتاپ دو ستونه‌ست و روی موبایل بدون اسکرول اضافه مرتب نمایش داده می‌شه.",
      },
      {
        type: "improved",
        text: "صفحه‌ی تنظیمات سازمان از نو با ظاهر بقیه‌ی پنل هماهنگ شد: تب‌ها، فرم اطلاعات، نشان و رنگ سازمان، جدول پرداخت‌ها، انتقال مالکیت، حذف سازمان و پنجره‌های تأیید حالا یک زبان بصری مشترک دارن.",
      },
      {
        type: "improved",
        text: "جاهایی که منظور سابقه‌ی تغییرات بود از «فعالیت» به «تاریخچه» تغییر نام دادن تا با ثبت زمان و گزارش کار قاطی نشن.",
      },
    ],
  },
  {
    version: "3.9.8",
    date: "2026-08-30",
    title: "چرخه‌ها اومدن، کارت تسک تمیز شد",
    changes: [
      {
        type: "new",
        text: "«چرخه‌ها» اومد؛ زیر منوی پروژه، درست زیر تسک‌ها. چرخه همون اسپرینته: یه بازه‌ی کوتاه، معمولاً دو هفته‌ای، که تیم توش روی چند تسک مشخص تمرکز می‌کنه. هر چرخه هدف، بازه، ظرفیت تیم (ساعت) و وضعیت خودش رو داره.",
      },
      {
        type: "new",
        text: "برنامه‌ریزی چرخه با دو ستون انجام می‌شه: بک‌لاگ و تسک‌های چرخه. چندتا تسک رو با هم تیک بزن و یکجا جابه‌جا کن. بالای صفحه هم می‌بینی چقدر از بازه گذشته، چقدر کار انجام شده و بار چرخه از ظرفیت تیم رد شده یا نه.",
      },
      {
        type: "new",
        text: "چرخه‌ها رو یکی‌یکی بساز، یا با یه تاریخ پایان کل سری رو خودکار بساز و بعداً تمدیدش کن. چرخه‌ی هر تسک رو از خود کارت تسک هم می‌تونی عوض کنی.",
      },
      {
        type: "improved",
        text: "کارت تسک شلوغی‌ش کم شد: حالا فقط وضعیت، کاربران، تاریخ اتمام و اولویت همیشه دیده می‌شن و بقیه‌ی ویژگی‌ها وقتی مقدار دارن ظاهر می‌شن. با «افزودن ویژگی» هر وقت خواستی بقیه رو باز می‌کنی.",
      },
      {
        type: "improved",
        text: "دیگه دکمه‌ی «ثبت تغییرات» توی کارت تسک نیست؛ هر فیلدی رو عوض کنی همون لحظه ذخیره می‌شه. ویژگی‌ها هم رفتن به یه ستون کنار محتوا تا توضیحات و زیرتسک‌ها بالاتر بیان.",
      },
      {
        type: "improved",
        text: "کامنت‌های تسک روی دسکتاپ هم تب خودشون رو گرفتن، با تعداد کامنت روی تب. تب‌های فعالیت‌ها و تاریخچه هم بازطراحی شدن و با بقیه‌ی پنل هم‌شکل شدن.",
      },
      {
        type: "fixed",
        text: "راهنمای صفحه‌ها دیگه بی‌خودی تکرار نمی‌شه: یک‌بار زدن دکمه‌ی راهنما باعث می‌شد تور هر بار که به اون تب برمی‌گشتی دوباره باز بشه.",
      },
      {
        type: "fixed",
        text: "کامنت‌های تسک توی حالت تیره ناخوانا بودن (متن سفید روی زمینه‌ی روشن) و رنگ سازمان رو هم نادیده می‌گرفتن. حالا از رنگ اکسنت سازمان استفاده می‌کنن.",
      },
    ],
  },
  {
    version: "3.9.7",
    date: "2026-08-29",
    title: "مشتریان برگشت، فضای کاری اندازه‌ی خودت",
    changes: [
      {
        type: "new",
        text: "توی راه‌اندازی فضای کاری یه قدم اضافه شد که ازت می‌پرسه کدوم بخش‌ها رو لازم داری. هر کدوم رو خاموش بذاری از منو و مسیرهای پنل برداشته می‌شه؛ هر وقت نظرت عوض شد از تنظیمات سازمان، تب «ماژول‌ها» روشنش کن. اطلاعات هیچ بخشی با خاموش‌کردنش پاک نمی‌شه.",
      },
      {
        type: "new",
        text: "بخش مشتریان برگشت و این بار پر و پیمون‌تر: هر مشتری صفحه‌ی خودش رو داره با تب‌های پروژه‌ها و تسک‌ها، یادداشت‌ها و فایل‌ها. لیست مشتری‌ها هم مثل بقیه‌ی لیست‌ها هم کارتی داره هم جدولی.",
      },
      {
        type: "new",
        text: "یادداشت‌های مشتری مثل تخته‌یادداشت پروژه‌ست، با این تفاوت که اسم نویسنده و پیوست هم داره. قرارداد و پیش‌فاکتور هم توی تب فایل‌های همون مشتری می‌مونه.",
      },
      {
        type: "new",
        text: "مشتری رو می‌تونی موقع ساخت پروژه یا از تنظیمات پروژه بهش وصل کنی، و توی فیلترهای لیست پروژه‌ها بر اساس مشتری فیلتر کنی. کارهای هر مشتری هم توی صفحه‌ی خودش جمع می‌شه.",
      },
      {
        type: "improved",
        text: "پنجره‌ی ساخت پروژه مرحله‌ای شد: اول اسم و تاریخ و قالب، بعد تیم و دسترسی، آخر مشتری و توضیحات. از همون مرحله‌ی اول هم می‌تونی پروژه رو بسازی و بقیه رو بعداً پر کنی.",
      },
      {
        type: "improved",
        text: "جست‌وجوی مشتری‌ها حالا شماره موبایل، ایمیل، کد مشتری و کد ملی رو هم می‌گیره؛ قبلاً فقط اسم رو پیدا می‌کرد.",
      },
      {
        type: "improved",
        text: "پروژه‌ی نمونه‌ای که موقع ساخت سازمان درست می‌شه دیگه برای هیچ‌کس ایمیل، پیامک و نوتیفیکیشن نمی‌فرسته. یه محیط تمرینه، نه یه پروژه‌ی واقعی.",
      },
      {
        type: "improved",
        text: "وقتی اشتراک سازمان اجازه‌ی کاری رو نده، به کسی که دسترسی خرید نداره دیگه دکمه‌ی «تهیه اشتراک» نشون داده نمی‌شه و به‌جاش بهش می‌گیم این کار از عهده‌ی مدیر سازمان برمیاد.",
      },
      {
        type: "fixed",
        text: "توی تب «نقشه‌ی وابستگی‌ها»، دکمه‌ی راهنما کنار عنوان هیچ‌وقت چیزی باز نمی‌کرد و گاهی راهنمای یه بخش دیگه به‌جاش می‌پرید وسط. درست شد.",
      },
      {
        type: "fixed",
        text: "توی صفحه‌ی مشتری، نوار «ذخیره تغییرات» به پایین صفحه نمی‌چسبید و وسط فرم شناور بود.",
      },
    ],
  },
  {
    version: "3.9.6",
    date: "2026-08-27",
    title: "شروع ساده‌تر، پیدا کردن سریع‌تر",
    changes: [
      {
        type: "new",
        text: "ثبت‌نام کوتاه شد: فقط اسم تیم، لوگو و حوزه‌ی فعالیت. بعدش یه مسیر قدم‌به‌قدم اولین پروژه‌ات رو می‌سازه، همکارات رو دعوت می‌کنه و مستقیم می‌بردت روی تخته‌ی پر — نه یه صفحه‌ی خالی.",
      },
      {
        type: "new",
        text: "بر اساس حوزه‌ی فعالیتت، قالب‌های آماده‌ی همون حوزه توی سازمانت ساخته می‌شن. الان بیش از سی قالب داریم؛ از توسعه‌ی نرم‌افزار و کمپین بازاریابی تا پروژه‌ی عمرانی، پرونده‌ی حقوقی، دوره‌ی آموزشی، سفارش و ارسال و نگهداری و تعمیرات. هر قالب پیش‌نمایش داره تا قبل از انتخاب ببینی چه ستون‌ها و تسک‌هایی داره.",
      },
      {
        type: "new",
        text: "با Ctrl+K (یا کلید /) یه جست‌وجوی سراسری باز می‌شه: تسک، زیرتسک، پروژه، آدم و دستورهای پرتکرار، همه یک‌جا. دیگه لازم نیست برای پیدا کردن یه تسک، پروژه‌ها رو یکی‌یکی باز کنی.",
      },
      {
        type: "new",
        text: "تب «وابستگی‌ها» جای درخت قبلی نشست: هر تسک یه کارته و با کشیدن از یه کارت روی کارت دیگه مشخص می‌کنی کدوم منتظر کدومه. تسک‌هایی که هیچی جلوشون رو نگرفته با علامت سبز مشخص می‌شن — یعنی همین حالا می‌شه شروعشون کرد.",
      },
      {
        type: "new",
        text: "گانت حالا فلش وابستگی می‌کشه و طولانی‌ترین زنجیره‌ی پروژه رو نارنجی نشون می‌ده. تسک‌های بدون تاریخ هم دیگه از نمودار حذف نمی‌شن؛ کنارش توی لیست «بدون زمان‌بندی» می‌مونن و با کشیدنشون روی نمودار زمان‌بندی می‌شن.",
      },
      {
        type: "new",
        text: "صفحه‌ی «همه تسک‌ها» اضافه شد که تسک‌های کل سازمان رو یک‌جا نشون می‌ده، با تب «مال خودم» برای برگشتن به تسک‌های خودت.",
      },
      {
        type: "improved",
        text: "لیست کاربران، تیم‌ها، نقش‌ها، برچسب‌ها و قالب‌ها کارتی شدن و هر کدوم چیزی رو نشون می‌دن که واقعاً به دردت می‌خوره: چهره‌ی اعضای تیم، دسترسی‌های هر نقش، رنگ واقعی هر برچسب و ستون‌های هر قالب. نمای جدولی هم با یک کلیک برمی‌گرده.",
      },
      {
        type: "improved",
        text: "هر کسی که عکس نذاشته، یه آواتار با حروف اسمش و رنگ ثابت خودش می‌گیره، همه‌جای برنامه یکسان. لیست پروژه‌های منوی کناری هم شد پروژه‌های سنجاق‌شده و پروژه‌هایی که تازه باز کردی.",
      },
      {
        type: "improved",
        text: "روی موبایل یه نوار پایین اضافه شد که با یک لمس می‌بردت به امروز، تسک‌ها، پروژه‌ها و اعلان‌ها؛ به‌علاوه‌ی یه دکمه‌ی «+» برای ساختن سریع.",
      },
      {
        type: "improved",
        text: "رنگ‌ها یکدست شدن: از این به بعد هر رنگ توی کل برنامه یه معنی داره. «در حال انجام» دیگه نارنجی نیست، چون نارنجی یعنی خطر نه فعالیت. راهنمای صفحه‌ها هم دیگه خودشون باز نمی‌شن و هر وقت خواستی از دکمه‌ی راهنما بازشون می‌کنی.",
      },
      {
        type: "fixed",
        text: "توی گانت، کشیدن یه تسک باعث می‌شد اول به جای قبلیش برگرده و بعد بپره سر جای جدید، و ترتیب کل ردیف‌ها هم به هم بریزه. حالا تغییر همون‌جا می‌مونه و ردیف‌ها تکون نمی‌خورن.",
      },
      {
        type: "fixed",
        text: "شماره‌ها و اعداد توی فرم‌ها و لیست‌ها فارسی شدن و چند جا که نوشته بود «کار»، شد «تسک».",
      },
    ],
  },
  {
    version: "3.9.5",
    date: "2026-08-23",
    title: "زیرتسک‌ها جدی گرفته شدن",
    changes: [
      {
        type: "new",
        text: "جست‌وجوی تسک‌ها حالا یه پنجره‌ی مستقله و زیرتسک‌ها رو هم پیدا می‌کنه — چیزی که تا حالا اصلاً شدنی نبود، چون زیرتسک‌ها فقط زیر تسک والدشون دیده می‌شدن. نتیجه‌ها می‌گن هر کدوم زیر کدوم تسکه و با کلیک (یا Enter) همون‌جا باز می‌شن.",
      },
      {
        type: "new",
        text: "هر زیرتسک حالا صفحه‌ی کامل خودش رو داره؛ از کنار همون ردیف بازش می‌کنی، همه‌ی امکانات تسک عادی رو داره و از رنگ هدر و مسیر بالای صفحه می‌فهمی الان داخل کدوم زیرتسکی و از کدوم تسک اومدی. دکمه‌ی حذف و دراپ‌داون تغییر وضعیت هم همیشه کنار ردیف هستن، نه فقط وقتی موس روشون می‌ره.",
      },
      {
        type: "improved",
        text: "کلون کردن تسک، زیرتسک‌هاش رو هم با خودش می‌بره. کارت‌های تخته هم می‌گن چند تا از زیرتسک‌هاشون انجام شده و نوار پیشرفت رفته لبه‌ی پایین کارت — با موس روش، درصد دقیق تا دو رقم اعشار رو می‌بینی.",
      },
      {
        type: "fixed",
        text: "کارتی که بین دو کارت دیگه رها می‌کردی، بعد از ذخیره شدن یک خونه بالاتر یا پایین‌تر می‌نشست. ترتیب ستون‌ها حالا سمت سرور از نو و درست چیده می‌شه و جای خالی‌ای که تسک حذف‌شده جا می‌ذاشت هم خودش پر می‌شه.",
      },
      {
        type: "fixed",
        text: "لیست‌هایی مثل قالب پروژه، نقش‌ها و کاربران بعد از هر ویرایش ترتیبشون به هم می‌ریخت، چون هیچ ترتیب مشخصی براشون تعریف نشده بود. حالا جای هر ردیف سرجاش می‌مونه.",
      },
      {
        type: "improved",
        text: "ویرایش اطلاعات پروژه برای سازنده‌ی پروژه، مالک سازمان و کسانی که دسترسی مدیریت سازمان یا پروژه‌ها رو دارن باز است؛ بقیه همون صفحه رو فقط می‌بینن.",
      },
    ],
  },
  {
    version: "3.9.4",
    date: "2026-08-12",
    title: "پیشخوان از نو؛ حالا می‌گه چی معطل مونده",
    changes: [
      {
        type: "new",
        text: "پیشخوان یه نوار «نیازمند رسیدگی» گرفت که مستقیم می‌گه چی روی زمین مونده: تسک‌های عقب‌افتاده، پروژه‌هایی که از برنامه عقبن، کارای بی‌صاحب، تسک‌های بلاک‌شده و اونایی که هفته‌هاست تکون نخوردن. روی هر کدوم بزنی می‌ری سراغ همون لیست، و اگه چیزی اونجا نبود یعنی همه‌چی روی ریله.",
      },
      {
        type: "new",
        text: "اگه مدیر سازمانی، حالا می‌بینی همین لحظه کی روی چه تسکی تایمر روشن کرده و چقدر شده — بدون رفرش کردن صفحه. نمودار تازه‌ی «جریان کار روزانه» هم کنار هم نشون می‌ده هر روز چقدر کار جدید اومده و چقدر تموم شده؛ اگه ستون‌ها مدام از خط بالاتر بمونن یعنی صف کار داره بلند می‌شه.",
      },
      {
        type: "new",
        text: "پیشخوان کاربرها یه نوار «امروز» گرفت: تایمر فعالت، زمانی که امروز ثبت کردی و جلسه‌ها و یادآوری‌های امروزت، همه یک‌جا. پایین‌تر هم می‌بینی تسک‌های بازت بین پروژه‌ها چطور پخش شده.",
      },
      {
        type: "improved",
        text: "عددهای بالای پیشخوان دیگه بی‌زمینه نیستن؛ کنار هر کدوم می‌بینی نسبت به بازه‌ی قبل بهتر شدی یا بدتر. بازه‌ی زمانی پیشخوان هم مثل بقیه‌ی گزارش‌ها قابل انتخابه و کارت‌ها موقع عوض کردنش دیگه سفید نمی‌شن.",
      },
      {
        type: "improved",
        text: "«تسک‌های اخیر» و «تسک‌های فوری» از پیشخوان رفتن به صفحه‌ی تسک‌های من و اونجا با یک کلیک بینشون جابه‌جا می‌شی؛ حالا می‌تونی روشون جست‌وجو و فیلتر کنی و جزئیات هر تسک رو همون‌جا باز کنی.",
      },
      {
        type: "improved",
        text: "اعلان‌ها دیگه یکدست آبی نیستن؛ اعلان خوانده‌نشده با یه نشونه‌ی ظریف مشخص می‌شه و لیست کوتاه بالای صفحه هم همون شکل و شمایل بقیه‌ی برنامه رو گرفت. باز کردن اعلان هم دیگه کل صفحه رو از نو بار نمی‌کنه.",
      },
      {
        type: "fixed",
        text: "کارت «تسک‌های نزدیک به موعد» توی پیشخوان کاربر، تسک‌هایی که موعدشون گذشته بود رو اصلاً نمی‌شمرد؛ برای همین عدد بالای صفحه با لیست پایینش نمی‌خوند. حالا عقب‌افتاده‌ها کارت جدای خودشون رو دارن. کلیک روی آواتار همکارها هم که برای کاربرهای عادی بی‌اثر بود درست شد.",
      },
    ],
  },
  {
    version: "3.9.2",
    date: "2026-08-12",
    title: "گزارش‌های تازه، تقویم شمسی و ظاهر یکدست",
    changes: [
      {
        type: "new",
        text: "گزارش عملکرد کاربران از نو ساخته شد؛ حالا جدول نفر‌به‌نفر داری که نشون می‌ده هر نفر چند تسک تموم کرده، چندتا در جریان یا متوقفه، چندتا عقب افتاده، چند درصد به‌موقع تحویل داده و به‌طور میانگین چند روز تأخیر داشته.",
      },
      {
        type: "new",
        text: "گزارش عملکرد پروژه‌ها جدول «سلامت پروژه‌ها» گرفت؛ با یک نگاه می‌فهمی هر پروژه چقدر جلو رفته، چقدر انتظار می‌رفت جلو رفته باشه و چقدر از برنامه عقبه. کارت پروژه‌های عقب‌افتاده هم اضافه شد.",
      },
      {
        type: "new",
        text: "گزارش فعالیت‌ها حالا تفکیک نفر‌به‌نفر و پروژه‌به‌پروژه داره و نشون می‌ده زمان واقعی صرف‌شده نسبت به تخمین اولیه چقدر بوده.",
      },
      {
        type: "improved",
        text: "تقویم حالا واقعاً ماه‌به‌ماه شمسیه؛ قبلاً هر صفحه بخشی از دو ماه رو با هم نشون می‌داد. صفحه‌ی اعلان‌ها هم بازطراحی شد و امکان دیدن همه‌ی اعلان‌ها، گروه‌بندی بر اساس زمان و فیلتر خوانده‌نشده‌ها رو گرفت.",
      },
      {
        type: "improved",
        text: "ظاهر صفحه‌ی گزارش‌ها، کارت‌ها و دکمه‌های خروجی اکسل در همه‌ی بخش‌ها یکدست شد، نمودارها با تعداد کم دیگه بی‌قواره نمی‌شن، و کنار انتخاب نوع ستون‌های تخته راهنمایی اضافه شد که می‌گه هر نوع چه تأثیری روی پیشرفت پروژه و گزارش‌ها داره.",
      },
      {
        type: "fixed",
        text: "شمارش تسک‌ها در گزارش فعالیت‌ها درست شد؛ قبلاً تسکی که چند روز روش کار شده بود چند بار شمرده می‌شد. عددهای بالای صفحه هم دیگه با انتخاب یک کاربر ناپدید نمی‌شن. تسک‌های در مرحله‌ی بررسی یا تست هم دیگه به اشتباه «شروع‌نشده» علامت نمی‌خورن.",
      },
    ],
  },
  {
    version: "3.9.0",
    date: "2026-08-11",
    title: "گزارش‌های تازه‌ی پروژه و رنگ سازمان در همه‌جا",
    changes: [
      {
        type: "new",
        text: "گزارش‌های پروژه از نو ساخته شدن؛ حالا در سه بخش «نمای کلی»، «تیم و جریان کار» و «ریسک و سلامت» می‌بینی پروژه چقدر جلو رفته، کار روی دوش کیه، کجا گیر کرده و چه تسک‌هایی عقب افتادن. بالای صفحه هم با یک جمله می‌گه از برنامه جلویی یا عقب و کِی احتمالاً تموم می‌شه.",
      },
      {
        type: "new",
        text: "توی دراپ‌داون‌های انتخاب تیم و کاربر، انتهای لیست گزینه‌ی ساخت مورد جدید اضافه شده؛ بعد از ساختن هم به همون فرمی که رهاش کردی برمی‌گردی.",
      },
      {
        type: "improved",
        text: "رنگی که برای سازمانت انتخاب می‌کنی حالا واقعاً همه‌جا اعمال می‌شه؛ دکمه‌ها، تب‌ها، آیکن‌ها، نمودارها و دکمه‌های شناور گفت‌وگو و پشتیبانی هم همرنگ می‌شن.",
      },
      {
        type: "improved",
        text: "فهرست فعالیت‌های اخیر پروژه بازطراحی شد و جست‌وجو و صفحه‌بندی گرفت. تسک‌های اخیر، فوری و اعلان‌ها هم با کلیک روی کل ردیف باز می‌شن و تاریخ سررسیدشون کنارشون دیده می‌شه.",
      },
      {
        type: "fixed",
        text: "«تسک‌های فوری» دیگه تسک‌های عقب‌افتاده رو جا نمی‌ندازه و اولویت تسک رو هم در نظر می‌گیره. «تسک‌های اخیر» هم بر اساس آخرین کاری که روشون شده مرتب می‌شه، نه تاریخ ساختشون.",
      },
      {
        type: "fixed",
        text: "متن «برآورد» در تم تیره دیگه سیاه و ناخوانا نیست.",
      },
    ],
  },
  {
    version: "3.8.0",
    date: "2026-08-10",
    title: "تسک‌های دقیق‌تر، آرشیو امن و ورود تازه",
    changes: [
      {
        type: "new",
        text: "کنار فیلترهای تسک‌های من، انتخاب سریع پروژه اضافه شده تا با یک انتخاب بین کارهای پروژه‌ها جابه‌جا بشی.",
      },
      {
        type: "improved",
        text: "تسک‌های پروژه‌های آرشیوی دیگه بین تسک‌های من، موعدهای نزدیک و گزارش‌های جاری نمایش داده نمی‌شن.",
      },
      {
        type: "improved",
        text: "صفحه‌های ورود، تکمیل مشخصات، انتخاب سازمان و ساخت سازمان با چیدمان تازه و هماهنگ با تم روشن و تیره بازطراحی شدن.",
      },
      {
        type: "improved",
        text: "تسک کلون‌شده درست بعد از تسک اصلی قرار می‌گیره و اکشن‌های کارت مرتب‌تر و در سمت چپ کارت دیده می‌شن.",
      },
      {
        type: "fixed",
        text: "پروژه‌های آرشیوی و تسک‌های دوره‌ای اون‌ها حالا بدون خطای نمایش باز می‌شن و تا زمان خروج از آرشیو، تغییر یا حذف ناخواسته ممکن نیست.",
      },
    ],
  },
  {
    version: "3.7.7",
    date: "2026-08-09",
    title: "قالب‌های آماده، اشتراک تازه و راهنمای جدید",
    changes: [
      {
        type: "new",
        text: "قالب‌های پیش‌فرض تسکامون حالا صفحه‌ی خودشون رو دارن؛ قبل از استفاده می‌تونی ستون‌ها، تسک‌های آماده و پیش‌نمایش تصویری هر قالب رو ببینی.",
      },
      {
        type: "improved",
        text: "صفحه‌ی اشتراک‌ها از نو طراحی شد؛ اشتراک‌ها یکدست‌تر کنار هم چیده شدن و تعداد کاربر و فضای انتخابیت رو همون‌جا به‌صورت عدد می‌بینی.",
      },
      {
        type: "improved",
        text: "نمایش اشتراک‌های اشتراک در تبلت و موبایل مرتب‌تر شده و کارت‌ها هم‌اندازه و هم‌ترازن.",
      },
      {
        type: "improved",
        text: "هر جا لیستی خالی باشه، به‌جای صفحه‌ی سفید یه توضیح کوتاه و دکمه‌ی ساخت می‌بینی تا بدونی قدم بعدی چیه.",
      },
      {
        type: "fixed",
        text: "دکمه‌های شناور پشتیبانی و گفت‌وگو دیگه روی پنجره‌های باز نمی‌افتن.",
      },
    ],
  },
  {
    version: "3.7.5",
    date: "2026-08-07",
    title: "انتخاب تاریخ تازه و تجربه‌ی بهتر داشبورد در موبایل",
    changes: [
      {
        type: "new",
        text: "انتخابگر تاریخ از نو ساخته شد تا انتخاب تاریخ شمسی و ساعت ساده‌تر، سریع‌تر و خواناتر باشه.",
      },
      {
        type: "improved",
        text: "تقویم جدید کاملاً راست‌چین شده و ظاهرش با رنگ سازمان و تم روشن یا تیره هماهنگه.",
      },
      {
        type: "improved",
        text: "انتخاب تاریخ و ساعت در فرم رویدادها، یادآوری‌ها، پروژه‌ها و تسک‌ها حالا تجربه‌ی یکدست‌تری داره.",
      },
      {
        type: "improved",
        text: "چیدمان هر دو داشبورد مدیر و کاربر در موبایل مرتب‌تر شده و کنترل‌های بالای صفحه بهتر کنار هم قرار می‌گیرن.",
      },
      {
        type: "improved",
        text: "دسترسی سریع با زیادشدن میان‌برها در صفحه‌های کوچک هم چیدمان مناسب خودش رو حفظ می‌کنه.",
      },
      {
        type: "fixed",
        text: "اسکرول افقی ناخواسته‌ی داشبورد در موبایل برطرف شد.",
      },
      {
        type: "fixed",
        text: "نوار جابه‌جایی بین نمای کلی، تسک‌های من و تقویم من دوباره در صفحه‌ی تقویم موبایل در دسترسه.",
      },
    ],
  },
  {
    version: "3.7.4",
    date: "2026-08-07",
    title: "داشبوردهای دقیق‌تر، گزارش‌های خواناتر و انتخاب بازه‌ی سریع",
    changes: [
      {
        type: "new",
        text: "در داشبورد و گزارش‌ها می‌تونی با یک انتخاب ساده، اطلاعات ۷، ۳۰ یا ۹۰ روز اخیر رو ببینی.",
      },
      {
        type: "improved",
        text: "آمار تسک‌ها و پروژه‌های انجام‌شده حالا دقیقاً با بازه‌ای که انتخاب کردی هماهنگه.",
      },
      {
        type: "improved",
        text: "نمودار انجام روزانه‌ی تسک‌ها مرتب‌تر شده و در بازه‌های طولانی هم تاریخ‌ها واضح و خلوت دیده می‌شن.",
      },
      {
        type: "improved",
        text: "تسک‌های اخیر و فوری در هر دو داشبورد با ترتیب درست نمایش داده می‌شن تا موارد مهم‌تر زودتر دیده بشن.",
      },
      {
        type: "improved",
        text: "گزارش تاریخچه حالا با کاربر، پروژه و بازه‌ی زمانی قابل فیلتره و خروجی اکسل هم همون انتخاب‌ها رو حفظ می‌کنه.",
      },
      {
        type: "improved",
        text: "ظاهر گزارش‌ها در موبایل، دسکتاپ و حالت روشن یا تیره یکدست‌تر و خواناتر شده.",
      },
      {
        type: "fixed",
        text: "اسکرول افقی ناخواسته در گزارش پروژه، گانت و صفحه‌ی اطلاعات پروژه برطرف شد.",
      },
      {
        type: "fixed",
        text: "چند ناهماهنگی در خروجی‌های اکسل، نمودارها و نمایش اعلان‌های داشبورد اصلاح شد.",
      },
    ],
  },
  {
    version: "3.7.3",
    date: "2026-08-07",
    title: "برآورد زمان تسک، کامنت‌های خواناتر و اسکرول یکدست",
    changes: [
      {
        type: "new",
        text: "برای هر تسک برآورد زمان بذار؛ از ۱۵ دقیقه تا ۲ هفته، تا حجم کار قبل از شروع روشن‌تر باشه.",
      },
      {
        type: "new",
        text: "تسک‌های انجام‌شده حالا تاریخ تکمیل رو نشون می‌دن و با نگه‌داشتن نشانگر روی اون، می‌بینی انجام تسک چقدر طول کشیده.",
      },
      {
        type: "improved",
        text: "کامنت‌های تسک از نو مرتب شدن: منشن و فایل داخل کادر نوشتن دیده می‌شن، منشن‌ها توی متن مشخصن و عملیات کامنت دم دست قرار گرفته.",
      },
      {
        type: "improved",
        text: "مشخصات تسک جمع‌وجورتر شد؛ تاریخ شروع و پایان، برآورد، ثبت فعالیت و برچسب‌ها حالا مرتب‌تر و یکدست‌تر کنار هم نشستن.",
      },
      {
        type: "improved",
        text: "اسکرول‌بارها در تخته، گانت، گفتگوها، منوها و پنجره‌های انتخاب ظاهر یکسانی گرفتن و با تم روشن و تیره هماهنگ شدن.",
      },
      {
        type: "fixed",
        text: "فاصله‌ی آیکن و متن در انتخابگر تاریخ اصلاح شد و گزینه‌های پاک‌کردن، امروز و تأیید هم همیشه در دسترسن.",
      },
    ],
  },
  {
    version: "3.7.0",
    date: "2026-08-03",
    title: "فضای کاری مرتب‌تر پروژه، دسترسی سریعِ هوشمند و پشتیبانی یک‌کلیکه",
    changes: [
      {
        type: "new",
        text: "«دسترسی سریع» بازطراحی شد: حالا می‌تونی یک پروژه، هر کدوم از صفحه‌هاش، یک ویوی ذخیره‌شده یا حتی یک تسک مشخص رو سنجاق کنی.",
      },
      {
        type: "new",
        text: "کارت‌های دسترسی سریع با کشیدن جابه‌جا می‌شن و جای خالی هر ردیف، دکمه‌ی افزودن میان‌بره.",
      },
      {
        type: "new",
        text: "دکمه‌ی پشتیبانی همیشه در دسترس: سوال، مشکل یا پیشنهادت رو همون‌جا به‌صورت تیکت برامون بفرست.",
      },
      {
        type: "new",
        text: "ویو رو یکجا بساز؛ اسم و فیلترهاش با هم انتخاب می‌شن و بعداً هم از یک پنجره ویرایش می‌شن.",
      },
      {
        type: "improved",
        text: "منوی پروژه مرتب شد: تخته، گانت، لیست و درخت زیر «تسک‌ها»، گزارش‌ها و اطلاعات پروژه هم جدا و سرجای خودشون.",
      },
      {
        type: "improved",
        text: "با باز کردن هر پروژه مستقیم روی تخته می‌ری، بدون یک کلیک اضافه.",
      },
      {
        type: "improved",
        text: "همه‌ی نماهای تسک یک نوار مشترک دارن: ویوها، جست‌وجو، فیلتر و خروجی اکسل، تمیز و در یک خط.",
      },
      {
        type: "improved",
        text: "کلیک روی «پروژه‌ها» در منوی کناری مستقیم لیست پروژه‌ها رو باز می‌کنه و «پروژه جدید» درست زیر «همه» نشسته.",
      },
      {
        type: "improved",
        text: "کلیک روی لوگو، از هر جای نرم‌افزار برت می‌گردونه به داشبورد.",
      },
      {
        type: "improved",
        text: "پنجره‌های وضعیت، اطلاعات پروژه و ویو ظاهر یکدستی با بقیه‌ی محیط گرفتن؛ در تم روشن و تیره.",
      },
      {
        type: "improved",
        text: "گفتگوی شناور در دسکتاپ جای بهتری گرفت و کمتر جلوی محتوا رو می‌گیره.",
      },
      {
        type: "fixed",
        text: "در صفحه‌ی ثبت تیکت، دکمه‌ی ثبت به پایین صفحه چسبید.",
      },
      {
        type: "fixed",
        text: "حذف یک ویو گاهی ویوی دیگری را حذف می‌کرد.",
      },
    ],
  },
  {
    version: "3.6.8",
    date: "2026-07-29",
    title: "تسک‌های من، فیلترهای یکدست و تخته‌ی بازنویسی‌شده",
    changes: [
      {
        type: "new",
        text: "صفحه‌ی «تسک‌های من»: همه‌ی تسک‌هات از همه‌ی پروژه‌ها یکجا، با پنل جزئیات کنار لیست.",
      },
      {
        type: "new",
        text: "فیلتر پروژه در «تسک‌های من» — با انتخاب پروژه، لیست مستقیم از تسک‌های همون پروژه خونده می‌شه.",
      },
      {
        type: "new",
        text: "چک‌باکس روی زیرتسک‌ها: با یه کلیک به وضعیت «انجام شده» می‌رن و نوار پیشرفت فوری آپدیت می‌شه.",
      },
      {
        type: "new",
        text: "همین صفحه‌ی تغییرات، تا بدونی هر نسخه چی آورده.",
      },
      {
        type: "improved",
        text: "فیلترها همه‌جا از کشوی کناری به مودال طراحی‌شده منتقل شدن و ظاهر یکسانی گرفتن.",
      },
      {
        type: "improved",
        text: "دراپ‌دان وضعیت تسک بازنویسی شد و حالا با تم روشن و تیره هماهنگه.",
      },
      {
        type: "improved",
        text: "مودال‌های تقویم، سازمان جدید و بروزرسانی روی پوسته‌ی مشترک دیزاین‌سیستم نشستن.",
      },
      {
        type: "fixed",
        text: "دراپ‌دان تیم در فیلتر تخته خالی نشون داده می‌شد.",
      },
      {
        type: "fixed",
        text: "تاریخ‌ها در فیلترها تمام‌عرض ستون خودشون نمی‌شدن.",
      },
    ],
  },
];

export const APP_VERSION = CHANGELOG[0]?.version || "1.0.0";

export const CHANGE_TYPES = {
  new: { label: "جدید", tone: "green" },
  improved: { label: "بهبود", tone: "blue" },
  fixed: { label: "رفع اشکال", tone: "orange" },
};
